<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/provisioningDevice" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.CreateDevice") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ProvisioningSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ProvisioningSystem')"
                >
                  <v-select
                    label="item"
                    v-model="hardwareSystem"
                    :options="proSystemList"
                    @input="selectedHardware(hardwareSystem)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ItemClass")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ItemClass')"
                >
                  <v-select
                    label="item"
                    v-model="itemClass"
                    :options="itemClassList"
                    @input="selectedItemClass(itemClass)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createHardwarePlan"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "" },
        {
          name: this.$t("system.label.ProvisioningDevice"),
          to: "/provisioningDevice",
        },
        {
          name: this.$t("system.label.CreateHardwarePlan"),
          to: "/",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      HardwarePlanData: {},
      hardwareSystem: "",
      proSystemList: [],
      provisioningId: 0,
      itemClass: "",
      itemClassList: [],
      itemClassId: 0,
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    async getTemplateData() {
      try {
        const response = await this.$store.dispatch(
          "provisioningConfig/getCreatehardwareMappingTemplate"
        );
        this.HardwarePlanData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    selectedHardware(off) {
      this.HardwarePlanData.provisioning.map((e) => {
        if (e.systemname == off) {
          this.provisioningId = e.id;
        }
      });
    },
    selectedItemClass(off) {
      this.HardwarePlanData.itemClassData.map((e) => {
        if (e.type == off) {
          this.itemClassId = e.id;
        }
      });
    },
    async createHardwarePlan() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let payload = {
          itemClass: this.itemClassId,
          provisioningId: this.provisioningId,
        };
        await this.$store.dispatch(
          "provisioningConfig/createHardwareMappingAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Provisioning Device Created Successfully!",
          type: "success",
        });
        this.$router.push("/provisioningDevice");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.hardwareSystem = "";
      this.itemClass = "";
    },
  },
  watch: {
    HardwarePlanData(val) {
      for (let role of val.provisioning) {
        this.proSystemList.push(role.systemname);
      }
      for (let role of val.itemClassData) {
        this.itemClassList.push(role.type);
      }
    },
  },
  mounted() {
    this.getTemplateData();
  },
};
</script>
